import { render, staticRenderFns } from "./DotsFilterBox.vue?vue&type=template&id=05b00fe6&scoped=true"
import script from "./DotsFilterBox.vue?vue&type=script&lang=js"
export * from "./DotsFilterBox.vue?vue&type=script&lang=js"
import style0 from "./DotsFilterBox.vue?vue&type=style&index=0&id=05b00fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b00fe6",
  null
  
)

export default component.exports